interface SpinnerProps {
  /** Zusätzliche CSS-Klassen für den äußeren Container */
  className?: string;
}

export default function Spinner({ className }: SpinnerProps) {
  return (
    <div className={`flex justify-center py-12 ${className ?? ''}`}>
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
    </div>
  );
}
